<template>
  <div>
    <div class="row mb-5">
      <div class="col-12" style="display: flex; align-items: center">
        <span class="display-4">
          {{ `${establishment.company_name}` }} -
          {{ $t("EQUIPMENT_TRANSFERS.MENU_TITLE") }}
        </span>
        <base-button
          v-if="
            establishment.active &&
            $currentUserCan($permissions.PERM_CREATE_EQUIPMENT_TRANSFERS)
          "
          type="primary"
          icon
          size="sm"
          @click="
            () => {
              showAddModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-single-copy-04"></i>
            {{ $t("COMMON.ADD") }}
          </span>
        </base-button>
      </div>
    </div>

    <equipment-transfer-list-table
      ref="equipmentTransferTable"
      :filterEstablishment="establishment.id"
      :hideAddButton="true"
    />

    <establishment-view-equipment-transfers-add-modal
      :establishment="establishment"
      :showModal="showAddModal"
      @onCloseModal="showAddModal = false"
      @created="refreshTransfers"
    />
  </div>
</template>

<script>
import EquipmentTransferListTable from "@/views/Pages/InventoryModule/EquipmentTransferManagement/partials/EquipmentTransferListTable.vue";
import EstablishmentViewEquipmentTransfersAddModal from "./EstablishmentViewEquipmentTransfersAddModal.vue";

export default {
  name: "EstablishmentViewEquipmentTransfers",
  components: {
    EquipmentTransferListTable,
    EstablishmentViewEquipmentTransfersAddModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAddModal: false,
    };
  },
  methods: {
    refreshTransfers() {
      this.$refs.equipmentTransferTable?.getList();
    },
  },
};
</script>
